import {ISearchDialogue} from './interfaces';
import {IAction} from '../interface';
import {InferActionsTypes} from '../helpers';

export const SET_SEARCH_DIALOGUES = 'SET_SEARCH_DIALOGUES';
export const setSearchDialogues = (dialogues: ISearchDialogue[]): IAction<ISearchDialogue[]> => ({
  type: SET_SEARCH_DIALOGUES,
  payload: dialogues
});

export const SET_SEARCH_DIALOGUE = 'SET_SEARCH_DIALOGUE';
export const setSearchDialogue = (dialogue: ISearchDialogue): IAction<ISearchDialogue> => ({
  type: SET_SEARCH_DIALOGUE,
  payload: dialogue
});

export const CLEAR_SEARCH_DIALOGUE = 'CLEAR_SEARCH_DIALOGUE';
export const clearSearchDialogue = (): IAction<null> => ({
  type: CLEAR_SEARCH_DIALOGUE,
  payload: null
});

const searchActions = {
  setSearchDialogues,
  setSearchDialogue,
  clearSearchDialogue
};

export type SearchActionsType = InferActionsTypes<typeof searchActions>
